import { jsxs as e, Fragment as C, jsx as l } from "react/jsx-runtime";
const d = () => /* @__PURE__ */ e(C, { children: [
  /* @__PURE__ */ l(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.50001 6.25C9.78206 6.25 10.0403 6.40824 10.1683 6.65956L14.4463 15.0572L15.8505 12.625C15.9845 12.3929 16.2321 12.25 16.5 12.25C16.768 12.25 17.0156 12.3929 17.1495 12.625L21.0467 19.375C21.1806 19.6071 21.1806 19.8929 21.0467 20.125C20.9127 20.3571 20.6651 20.5 20.3971 20.5H3.00482C2.74389 20.5 2.50171 20.3644 2.36536 20.1419C2.22901 19.9194 2.2181 19.6421 2.33654 19.4096L8.83173 6.65956C8.95976 6.40824 9.21796 6.25 9.50001 6.25Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9Z",
      fill: "currentColor"
    }
  )
] });
export {
  d as default
};
